import { VisuallyHidden } from 'react-aria';
import { Minus, Plus } from '@hungryroot/icons';
import { Paragraph } from '@hungryroot/ramen';
import styles from './ControlRange.module.css';

interface Props {
  testid?: string;
  label: string;
  count: number | null;
  className?: string;
  onChange: (value: number) => void;
  min: number;
  max: number;
}

export function ControlRange(props: Props) {
  const { onChange, testid, label, count, className, min, max } = props;

  return (
    <div data-testid={testid} className={className}>
      <label className={styles['control-range-number-input-wrapper']}>
        <Paragraph>{label}</Paragraph>
        <div className={styles['control-range-number-input']}>
          <button
            type="button"
            onClick={() => {
              if (count !== null) {
                count - 1;
                onChange(count - 1);
              }
            }}
            disabled={count === min || count === null}
            data-testid={`${testid}-input-decrease`}
          >
            <Minus />
            <VisuallyHidden>Remove {label}</VisuallyHidden>
          </button>
          <input
            readOnly
            id={`${testid}-input`}
            value={count === null ? 0 : count}
            type="number"
            data-testid={`${testid}-input`}
            min="0"
            onChange={(evt) => {
              onChange(parseInt(evt.target.value, 10));
            }}
          ></input>
          <button
            type="button"
            onClick={() => {
              if (count !== null) count + 1;
              onChange(count === null ? 1 : count + 1);
            }}
            disabled={count === max}
            data-testid={`${testid}-input-increase`}
          >
            <Plus />
            <VisuallyHidden>Add {label}</VisuallyHidden>
          </button>
        </div>
      </label>
    </div>
  );
}
